function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var clickableStyles = {
  cursor: 'pointer',
  transition: 'background-color, outline-color 0.2s ease-in-out',
  outlineColor: 'transparent',
  _hover: {
    backgroundColor: 'neutral.lightest'
  },
  _focusVisible: {
    // A trick to avoid having the outline being cropped by the card container
    // https://stackoverflow.com/a/35201368
    outlineOffset: '-2px',
    outlineColor: 'focus.focus',
    transition: 'outline-color 0.2s'
  },
  _active: {
    backgroundColor: 'neutral.lighter'
  }
};
var unclickableStyles = {
  _hover: {
    backgroundColor: 'initial'
  },
  _active: {
    backgroundColor: 'initial'
  },
  _disabled: {
    cursor: 'not-allowed'
  },
  _readOnly: {
    cursor: 'default'
  }
};
export var getSharedCellStyles = (isClickable, textAlign) => _objectSpread({
  display: 'flex',
  justifyContent: textAlign,
  width: '100%',
  height: '100%',
  padding: 's',
  textAlign
}, isClickable ? clickableStyles : unclickableStyles);
export var tableCellTheme = {
  baseStyle: _ref => {
    var {
      hasChildren,
      isClickable,
      textAlign
    } = _ref;
    return _objectSpread(_objectSpread({}, getSharedCellStyles(isClickable, textAlign)), {}, {
      backgroundColor: 'initial',
      alignItems: 'center',
      textStyle: 'body3',
      textAlign,
      color: hasChildren ? 'neutral.black' : 'neutral.darker'
    });
  },
  defaultProps: {
    textAlign: 'start'
  }
};
//# sourceMappingURL=_TableCell.theme.js.map